export default __webpack_public_path__ + "static/media/colors-1920w.b64ae68d.avif";